import { Camera, FileText, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const steps = [
  { icon: Camera, num: "1", title: "Send Your Photos", desc: "Tell us what you need done and upload photos so we can understand the job." },
  { icon: FileText, num: "2", title: "Get a Clear Quote", desc: "We provide straightforward pricing and explain what is included before work begins." },
  { icon: CheckCircle2, num: "3", title: "We Complete the Work", desc: "Our team shows up, completes the job properly and leaves the area clean." },
];

const HowItWorks = () => (
  <section id="how-it-works" className="bg-white py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        How It Works
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-lg mx-auto">
        Three simple steps to get your property job quoted and completed.
      </p>
      <div className="grid md:grid-cols-3 gap-10 max-w-4xl mx-auto">
        {steps.map((s) => (
          <div key={s.num} className="text-center">
            <div className="w-20 h-20 bg-yellow rounded-full flex items-center justify-center mx-auto mb-5">
              <s.icon className="w-9 h-9 text-dark" />
            </div>
            <h3 className="text-xl font-bold text-dark mb-2">{s.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <Link
          to="/get-quote"
          className="inline-block bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity"
        >
          Get Started — It's Free
        </Link>
      </div>
    </div>
  </section>
);

export default HowItWorks;
